<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <Breadscrumbs
      :links="[
        { name: 'QuikTips', to: { path: '/quiktips' } },
        { name: 'Edit', to: {
            name: 'QuikTipEdit',
            params: {
              id: $route.params.id
            }
          }
        },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 Quiktips</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- block -->
    <QuiktipsCreateEdit></QuiktipsCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import QuiktipsCreateEdit from '@/views/D-3_Quiktips/c/QuiktipsCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    QuiktipsCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('QuikTip', ['quiktip']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getQuiktip(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('QuikTip', {
      getQuiktip: 'findById',
      saveQuiktip: 'save',
    }),
    cancelHandler() {
      this.$router.go(-1);
    },
    async saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.saveQuiktip(this.quiktip).then(() => {
          this.$router.push({ name: 'QuikTip' });
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
